import WeeklyMessageAttachmentContainer from './WeeklyMessageAttachmentContainer';

export default WeeklyMessageAttachmentContainer;
